export enum AUTO_HIDE_SNACKBAR_MS {
  DEFAULT = 3000,
  MEDIUM_LARGE = 8000,
}
